import { storage } from '@/components/Storage.js';
import { flightSchedule } from '@/Pages/FlightSchedulePage.js';
import { modalContainerWarningCheckList } from '@/Modal/ModalContainerWarningCheckList.js';
import { modalContainerWarningCloseTask } from '@/Modal/ModalWarningCloseTask.js';

export const flightMenuBlock = {
    controller: function (args) {

        this.homeLink = args.menu.home;
        this.menuLinks = args.menu.tabs.map(function (item) {
            let arr = [];
            if(typeof item.tabs !== 'undefined') {
                for (let i = 0; i < item.tabs.length; ++i) {
                    arr[i] =  { icon: item.tabs[i].icon, url: '/task/' + m.route.param('taskId') + '/' + item.tabs[i].tab};
                }
            }
            else
                arr = null;
            return {
                icon: item.icon,
                tab: item.tab,
                url: '/task/' + m.route.param('taskId') + '/' + item.tab,
                tabs: arr
            };
        });
        for(let i = 0; i < this.menuLinks.length; i++) {
            let key = this.menuLinks[i].tab;
            this.menuLinks[key] = this.menuLinks[i];
        }
    },
    view: function (ctrl, args) {
        const isSecondRowOfButtonsExists = (args.tab == ctrl.menuLinks[args.tab].tab && ctrl.menuLinks[args.tab].tabs !== null);

        const result = m(".flight-menu-block", [
            // голубые кнопки режимов работы
            m(".flight-menu-tabs[style='margin:7px 0 0;padding:0;border:none;']", [
                m(".d-flex.flex-justify", {
                    config: function (element, isInitialized) {
                        if (!isInitialized) {
                            document.addEventListener('onlineChange', function (e) {
                                element.childNodes.forEach(function (obj) {
                                    const skillId = args.currentTask['skillId'] ? args.currentTask['skillId'].toString() : null;
                                    const workPlace = args.currentTask['workPlace'] ? args.currentTask['workPlace'].toString() : null;
                                    const skillsFuelTab = storage.config?.SkillsFuelTab.split(';')?? '';
                                    // Если вкладка Центровка и Роль не Супервайзер (1)
                                    if (obj.href.indexOf('centering') > -1 && workPlace != '1'){
                                        // Если есть нужный скил - Показываем вкладку, иначе  Скрываем вкладку
                                        skillsFuelTab.indexOf(skillId) > -1 ? obj.classList.remove('disabled') : obj.classList.add('disabled');
                                    }else {
                                        // Только если работа привязана к рейсу
                                        if (args.currentTask.flightId > 0 && args.currentTask.isConfirmed) {
                                            e.detail.online ? obj.classList.remove('disabled') : obj.classList.add('disabled');
                                        }
                                    }
                                })
                            });
                        }
                    }
                }, [
                    // Кнопка "Главная"
                    m("a.btn.btn-info.btn-lg.flex-grow-1", {
                        href: ctrl.homeLink.url,
                        class: (m.route() === ctrl.homeLink.url ? 'active' : ''),
                        config: m.route
                    }, [
                        m("i.fa.fa-2x.fa-" + ctrl.homeLink.icon)
                    ]),
                    // кнопки - табы
                    ctrl.menuLinks.map(function (link) {
                        const workplace = args.currentTask['workPlace'] || args.currentTask['userWorkplace']
                        return m("a.btn.btn-info.btn-lg.flex-grow-1", {
                            href: link.url,
                            class: (!args.currentTask.isConfirmed
                                || (args.currentTask.flightId == 0 && m.route() !== link.url )
                                // Если есть нужный скил - Показываем вкладку, иначе скрываем вкладку
                                || ((link.url.indexOf('centering') > -1  && workplace?.toString() != '1' )
                                    && args.currentTask['skillId'] && storage.config.SkillsFuelTab.split(';').indexOf(args.currentTask['skillId'].toString()) == -1)
                                )
                                ? 'disabled'
                                : (m.route() === link.url || (link.tab == "info" && (m.route().split('/')[3] == "photo" || m.route().split('/')[3] == "gallery" || m.route().split('/')[3] == "checklist")) ? 'active' : ''),
                            config: m.route
                        }, [
                            m("i.fa.fa-2x", {class: 'fa-' + link.icon})
                        ])
                    })
                ]),

                args.currentTask.isConfirmed && isSecondRowOfButtonsExists
                    ? m("div[style='margin: 3px;']",
                        m(".btn-group.btn-group-sm.btn-group-justified[role='group']",
                            ctrl.menuLinks[args.tab].tabs.map(function (link) {
                                return m("div.btn.btn-default [style='border-radius: 15px;']", {
                                    id: link.icon == "camera" ? 'camera' : '',
                                    class: (m.route() === link.url ? 'active' : ''),
                                    onclick: function () {
                                        if (link.icon == "camera") {
                                            m.route(link.url);
                                        } else
                                            m.route(link.url);
                                    }
                                }, [
                                    m("i.fa.fa-2x", {class: 'fa-' + link.icon}),
                                ]);
                            })                  
                        )          
                    ) 
                    : []
            ]),
            // старый вариант информации о борте на синем фоне
            (!args.showOldBoardInfo === false)
            ? null
            : m(".board-info.bg-primary[style='margin:7px 0 0; padding:7px']", [
                m(".container.text-center", [
                    m("div[style='display:inline-block;margin-right:15px']", "Борт: " + (args.board.boardNumber || '') + " [" + args.board.flightChain + "] "),
                    args.board.alertsExists ? m("i.fa.fa-warning", {
                        onclick: function () {
                            alert(args.board.alerts.map(function(alert) {
                                return "[" + alert.code + "] " + alert.desc + " - " + alert.amount;
                            }).join("\n"));
                        }
                    }) : ''
                ])
            ]),
            // select для выбора тасков
            (args.showTaskSelect === false) 
            ? null 
            : m("div[style='padding:3px']", [
                m(".container[style='padding:0']", [
                    args.schedules ?
                        [
                            m(".col-xs-7[style='padding:0 3px']", [
                                m("select.form-control[style='font-weight:bold']", {
                                    onchange: function (e) {
                                        const taskId = e.target.value;
                                        let isTaskConfirmed = false;
                                        args.tasks.forEach(function (item) {
                                            if (item.taskId == taskId) {
                                                isTaskConfirmed = item.isConfirmed;
                                            }
                                        });
                                        m.route('/task/' + taskId + '/' + (isTaskConfirmed ? args.tab : 'info'));
                                    }
                                }, [
                                    args.tasks.map(function(task) {
                                        return m("option[style='font-weight:bold']", {
                                            value: task.taskId,
                                            selected: task.isCurrent
                                        }, task.flightNumber + " [" + task.flightTime + "] <" + (task.parkingNumber || '-') + ">");
                                    })
                                ])
                            ]),
                            m(".col-xs-5[style='padding:0 3px']", [
                                m("select.form-control[style='font-weight:bold']", {
                                    disabled: args.schedules.length === 0 ? 'disabled' : false,
                                    onchange: function (e) {
                                        flightSchedule.changeSchedule(e.target.value);
                                    }
                                }, [
                                    args.schedules.map(function(schedule) {
                                        return m("option[style='font-weight:bold']", {
                                            value: schedule.number,
                                            selected: schedule.number == flightSchedule.scheduleNumber
                                        }, `${schedule.number}  ${schedule.boardNumber ? " [" + schedule.boardNumber + "]" : ''}`)
                                    })
                                ])
                            ])
                        ] :
                        m("select.form-control", {
                            onchange: function (e) {
                                const taskId = e.target.value;
                                let isTaskConfirmed = false;
                                args.tasks.forEach(function (item) {
                                    if (item.taskId == taskId) {
                                        isTaskConfirmed = item.isConfirmed;
                                    }
                                });
                                m.route('/task/' + taskId + '/' + (isTaskConfirmed ? args.tab : 'info'));
                            }
                        }, [
                            args.tasks.map(function(task) {
                                return m("option", {
                                    value: task.taskId,
                                    selected: task.isCurrent
                                }, task.flightNumber + " [" + task.flightTime + "] <" + (task.parkingNumber || '-') + ">");
                            })
                        ])
                ])
            ]),
            modalContainerWarningCheckList.init(),
            modalContainerWarningCloseTask.init(),
        ])

        return result;
    }
};
